import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialTypography from "../../../components/MaterialTypography";
import { Card, CardHeader, CardContent, Typography, Grid, Stack, Button, TextField } from '@mui/material';
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import moment from 'moment-timezone';
function WFHViewScreen() {
   const [employeeData,setemployeeData] = useState([])
   const navigate = useNavigate()
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        const id = queryParams.get("id")
        
        if (id) {
            getInitData(id)
        }
       
    }, [])


    const getInitData = async (id) => {
      
        const query = `  query user_wfh_details($id:String!){
  getWfhById(id:$id){
    id
    requestedDate
      startDate
      endDate
      reason
      totalDays
      status
      task
      teamApproval
      hrApproval
      lastUpdate
      user{
        id
        firstName
      }
  }
} `;
        try {
         
            const response = await axios.post(BASEURL, {
                query: query,
                variables: { id },
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            
            const regularizationRowdata = response.data.data.getRegularizationById;
            const weekoffRowdata = response.data.data.getWfhById;
            setemployeeData(weekoffRowdata)
          
        } catch (error) {
            console.error('ResponseError:', error);
          
        }
    };
    const checkInTime = moment(employeeData.checkIn).tz('Your/Timezone', true).format('M/D/YYYY, h:mm:ss a');
    const checkOutTime = moment(employeeData.checkOut).tz('Your/Timezone', true).format('M/D/YYYY, h:mm:ss a');
  
     

     function formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB'); // This will return 'dd/mm/yyyy' format
      }

      const handleclose = ()=>{
        navigate('/wfh-management')
      }
   
  return (
    <DashboardLayout>
         <Card sx={{ padding: 1, boxShadow: 4, borderRadius: 2 }}>
           {/* Card Title */}
           <CardHeader
             title={
               <Typography
                 variant="h5"
                 fontWeight="bold"
                 textAlign="center"
                 gutterBottom
               >
               WFH Details
               </Typography>
             }
           />
   
           {/* Leave Details Content */}
           <CardContent>
             <Grid container spacing={1} marginLeft={"4%"} >
               {/* Left Column */}
               <Grid item xs={12} sm={6}>
                 <Stack spacing={2}>
                   <Typography variant="h6">
                     <strong>User Name:</strong>{" "}
                     <span style={{ color: "#67748E" }}>
                       {employeeData?.user?.firstName?.toUpperCase()}
                     </span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>Start Date:</strong>{" "}
                     <span style={{ color: "#67748E" }}>
                       {employeeData?.startDate}
                     </span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>End Date:</strong>{" "}
                     <span style={{ color: "#67748E" }}>
                       {employeeData?.endDate}
                     </span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>Total Days:</strong>{" "}
                     <span style={{ color: "#67748E" }}>
                       {employeeData?.totalDays}
                     </span>
                   </Typography>
                 </Stack>
               </Grid>
   
               {/* Right Column */}
               <Grid item xs={12} sm={6}>
                 <Stack spacing={2}>
                   <Typography variant="h6">
                     <strong>Reason:</strong>{" "}
                     <span style={{ color: "#67748E" }}>
                       {employeeData?.reason}
                     </span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>Manager Approval:</strong>{" "}
                     <span style={{ color: "#67748E" }}>
                     {employeeData?.teamApproval == 'approved' ? "Approved": employeeData?.teamApproval == 'rejected'? "Rejected" : employeeData?.teamApproval }
                     </span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>HR Approval:</strong>{" "}
                     <span style={{ color: "#67748E" }}>
                     {employeeData?.hrApproval == 'approved' ? "Approved": employeeData?.hrApproval == 'rejected'? "Rejected" : employeeData?.hrApproval}
                     </span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>Status:</strong>{" "}
                     <span style={{ color: "#67748E" }}>
                     {employeeData?.status == 'approved' ? "Approved": employeeData?.status == 'rejected'? "Rejected" : employeeData?.status}
                     </span>
                   </Typography>
                 </Stack>
               </Grid>
             </Grid>
   
             {/* Buttons */}
              <Grid container spacing={2} justifyContent="center" marginTop={4}>
                    
                      <Grid item>
                           <MaterialButton
                             variant="contained"
                             color="dark"
                             onClick={() => handleclose()}
                           >
                             Close
                           </MaterialButton>
                         </Grid>
                   </Grid>
                   
           </CardContent>
         </Card>
       </DashboardLayout>
  );
}

export default WFHViewScreen;
